import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';

/**
 * Rende cliccabile l'anteprima di ogni file presente nella Dashboard di Uppy.
 * Al click sulla miniatura, il file selezionato viene aperto in una nuova
 * scheda del browser: anteprima diretta per i tipi visualizzabili (txt, pdf,
 * immagini), download per gli altri. Utile per verificare quale file si sta
 * allegando prima di inviare il form.
 *
 * Usa la event delegation sul contenitore (non sui singoli item) così da
 * sopravvivere ai re-render della Dashboard, gestita internamente da Preact.
 *
 * @param uppy         Istanza Uppy (Core) creata con `Uppy({...}).use(Dashboard, ...)`.
 * @param containerId  id dell'elemento target della Dashboard, senza '#'.
 */
export function enableUppyFilePreview(uppy: any, containerId: string): void {
    const container = document.getElementById(containerId);
    if (!container || container.dataset.uppyPreviewBound) {
        return;
    }
    container.dataset.uppyPreviewBound = "1";
    container.classList.add("uppy-has-preview");

    container.addEventListener("click", (event) => {
        const target = event.target as Element | null;
        // Apriamo l'anteprima solo se il click è dentro la miniatura del file,
        // così i pulsanti nativi (rimuovi, ecc.) continuano a funzionare.
        const item = target
            ?.closest(".uppy-Dashboard-Item-preview")
            ?.closest(".uppy-Dashboard-Item");
        if (!item || !item.id) {
            return;
        }

        const file = uppy.getFile(item.id.replace(/^uppy_/, ""));
        if (!file || !file.data) {
            return;
        }

        const url = URL.createObjectURL(file.data);
        window.open(url, "_blank");
        // Libera la memoria dopo che la nuova scheda ha caricato il contenuto.
        window.setTimeout(() => URL.revokeObjectURL(url), 60000);
    });
}
